"use client";

import FeedSearchWrapper, {
  FEED_SEARCH_TAB_ITEMS,
} from "@/components/app/feed/feed-search-wrapper/feed-search-wrapper";
import { FeedWrapperContextProvider } from "@/components/app/feed/feed-wrapper-context";
import { LocalStorageKeys } from "@/utils/local-storage-keys";

// TODO: add some metadata

export default function App() {
  return (
    <FeedWrapperContextProvider
      defaultActiveTab={FEED_SEARCH_TAB_ITEMS.POSTS}
      tabLocalStorageKey={LocalStorageKeys.searchFeedActiveTab}
    >
      <FeedSearchWrapper />
    </FeedWrapperContextProvider>
  );
}
